const products = {
  tshirts: {
    label: "T-SHIRTS",
    items: [
      {
        id: "ts1",
        name: "VOID TEE",
        price: 1299,
        tag: "BESTSELLER",
        images: [
          "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600&q=80",
          "https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=600&q=80",
          "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=600&q=80",
          "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=600&q=80",
        ],
      },
      {
        id: "ts2",
        name: "BLANK CANVAS TEE",
        price: 999,
        tag: null,
        images: [
          "https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=600&q=80",
          "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=600&q=80",
          "https://images.unsplash.com/photo-1562157873-818bc0726f68?w=600&q=80",
          "https://images.unsplash.com/photo-1631729371254-42c2892f0e6e?w=600&q=80",
        ],
      },
      {
        id: "ts3",
        name: "PHANTOM PRINT",
        price: 1499,
        tag: "NEW",
        images: [
          "https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?w=600&q=80",
          "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=600&q=80",
          "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=600&q=80",
          "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=600&q=80",
        ],
      },
      {
        id: "ts4",
        name: "BEIGE BEN10 TEE",
        price: 1199,
        tag: null,
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655203/1750415838_4107800_cutoej.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655203/1749817476_2237076_hbk0j6.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655203/1749817476_8136342_znyblc.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655204/1762940521_1365459_ylbbwi.avif",
        ],
      },
      {
        id: "ts5",
        name: "GREEN BEN10 TEE",
        price: 899,
        tag: "SALE",
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655203/1755170272_1070848_cp3bnf.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655203/1755170272_8454725_hhxpry.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655204/1755170272_9108692_mayhmf.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777655204/1755170272_9722648_kb1dek.avif",
        ],
      },
    ],
  },
  sweatshirts: {
    label: "SWEATSHIRTS",
    items: [
      {
        id: "sw1",
        name: "COLD WAVE HOODIE",
        price: 2999,
        tag: "BESTSELLER",
        images: [
          "https://images.unsplash.com/photo-1578768079052-aa76e52ff62e?w=600&q=80",
          "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?w=600&q=80",
          "https://images.unsplash.com/photo-1614252235316-8c857d38b5f4?w=600&q=80",
        ],
      },
      {
        id: "sw2",
        name: "SHADOW FLEECE",
        price: 2499,
        tag: "NEW",
        images: [
          "https://images.unsplash.com/photo-1509942774463-acf339cf87d5?w=600&q=80",
          "https://images.unsplash.com/photo-1588117305388-c2631a279f82?w=600&q=80",
          "https://images.unsplash.com/photo-1527719327859-c6ce80353573?w=600&q=80",
          "https://images.unsplash.com/photo-1563630423918-b58f07336ac9?w=600&q=80",
        ],
      },
      {
        id: "sw3",
        name: "VOID CREWNECK",
        price: 1999,
        tag: null,
        images: [
          "https://images.unsplash.com/photo-1564557287817-3785e38ec1f5?w=600&q=80",
          "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=600&q=80",
          "https://images.unsplash.com/photo-1608228088998-57828365d486?w=600&q=80",
          "https://images.unsplash.com/photo-1544816155-12df9643f363?w=600&q=80",
        ],
      },
      {
        id: "sw4",
        name: "RAWEDGE HOODIE",
        price: 3299,
        tag: "NEW",
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661090/plain_black_pwsuxp.webp",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661090/plain_cream_ulunvi.webp",
        ],
      },
      {
        id: "sw5",
        name: "STREET ARCH SWEAT",
        price: 2199,
        tag: null,
        images: [
          "https://images.unsplash.com/photo-1516826957135-700dedea698c?w=600&q=80",
          "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=600&q=80",
          "https://images.unsplash.com/photo-1529543544282-ea669407fca3?w=600&q=80",
          "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&q=80",
        ],
      },
    ],
  },
  jeans: {
    label: "JEANS",
    items: [
      {
        id: "j1",
        name: "ASPHALT SLIM",
        price: 3499,
        tag: "BESTSELLER",
        images: [
          "https://images.unsplash.com/photo-1542272604-787c3835535d?w=600&q=80",
          "https://images.unsplash.com/photo-1604176354204-9268737828e4?w=600&q=80",
          "https://images.unsplash.com/photo-1475178626620-a4d074967452?w=600&q=80",
          "https://images.unsplash.com/photo-1565084888279-aca607ecce0c?w=600&q=80",
        ],
      },
      {
        id: "j2",
        name: "BLACKOUT DENIM",
        price: 3999,
        tag: "NEW",
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660926/ChatGPT_Image_Apr_28_2026_10_36_17_PM_mqmghg.png",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660926/ChatGPT_Image_Apr_28_2026_10_36_25_PM_q4mhhu.png",
        ],
      },
      {
        id: "j3",
        name: "RAW HEM LOOSE",
        price: 3299,
        tag: null,
        images: [
          "https://images.unsplash.com/photo-1576995853123-5a10305d93c0?w=600&q=80",
          "https://images.unsplash.com/photo-1555689502-c4b22d76c56f?w=600&q=80",
          "https://images.unsplash.com/photo-1491553895911-0055eca6402d?w=600&q=80",
          "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=600&q=80",
        ],
      },
      {
        id: "j4",
        name: "CARGO HYBRID DENIM",
        price: 4299,
        tag: "NEW",
        images: [
          "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=600&q=80",
          "https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=600&q=80",
          "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600&q=80",
          "https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=600&q=80",
        ],
      },
      {
        id: "j5",
        name: "STREET TAPER",
        price: 2999,
        tag: "SALE",
        images: [
          "https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=600&q=80",
          "https://images.unsplash.com/photo-1520975954732-35dd22299614?w=600&q=80",
          "https://images.unsplash.com/photo-1516726817505-f5ed825624d8?w=600&q=80",
          "https://images.unsplash.com/photo-1523289333742-be1143f6b766?w=600&q=80",
        ],
      },
    ],
  },
  shirts: {
    label: "SHIRTS",
    items: [
      {
        id: "sh1",
        name: "URBAN OVERSHIRT",
        price: 2799,
        tag: "NEW",
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660834/blackovershirt_vxg2me.jpg",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660835/blackovershirt2_fbkmct.jpg",
        ],
      },
      {
        id: "sh2",
        name: "TOM AND JERRY OVERSHIRT",
        price: 2499,
        tag: null,
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660677/WhatsApp_Image_2026-05-01_at_14.58.05_1_dkeshw.jpg",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660677/WhatsApp_Image_2026-05-01_at_14.58.05_fz2gdk.jpg",
        ],
      },
      {
        id: "sh3",
        name: "COLD LINEN BUTTON-UP",
        price: 1999,
        tag: "BESTSELLER",
        images: [
          "https://images.unsplash.com/photo-1598033129183-c4f50c736f10?w=600&q=80",
          "https://images.unsplash.com/photo-1602810316498-ab67cf68c8e1?w=600&q=80",
          "https://images.unsplash.com/photo-1555689502-c4b22d76c56f?w=600&q=80",
          "https://images.unsplash.com/photo-1614251055880-ee96e4803393?w=600&q=80",
        ],
      },
      {
        id: "sh4",
        name: "GHOST OXFORD",
        price: 2299,
        tag: null,
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660494/WhatsApp_Image_2026-05-01_at_14.58.06_1_or2owh.jpg",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660485/WhatsApp_Image_2026-05-01_at_14.58.04_zrzbwm.jpg",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660495/WhatsApp_Image_2026-05-01_at_14.58.06_blsgbs.jpg",
        ],
      },
      {
        id: "sh5",
        name: "UTILITY TECH SHIRT",
        price: 3199,
        tag: "NEW",
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660291/WhatsApp_Image_2026-05-01_at_14.41.08_uviexl.jpg",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777660301/WhatsApp_Image_2026-05-01_at_23.57.07_qnhmu3.jpg",
        ],
      },
    ],
  },
  outerwear: {
    label: "OUTERWEAR",
    items: [
      {
        id: "ow1",
        name: "PHANTOM PARKA",
        price: 7999,
        tag: "NEW",
        images: [
          "https://images.unsplash.com/photo-1544441893-675973e31985?w=600&q=80",
          "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=600&q=80",
          "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=600&q=80",
        ],
      },
      {
        id: "ow2",
        name: "VOID BOMBER",
        price: 5999,
        tag: "BESTSELLER",
        images: [
          "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=600&q=80",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661168/bomber_ev25nc.jpg",
        ],
      },
      {
        id: "ow3",
        name: "LEATHER JACKET",
        price: 4999,
        tag: null,
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661521/leatherjacket1_ky8hlu.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661521/leatherjacket1_ky8hlu.avif",
        ],
      },
      {
        id: "ow4",
        name: "STREET TRENCH",
        price: 6499,
        tag: "NEW",
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661622/TRENCH_COAT_tp2rbk.jpg",
          "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=600&q=80",
          "https://images.unsplash.com/photo-1552902865-b72c031ac5ea?w=600&q=80",
        ],
      },
      {
        id: "ow5",
        name: "MINIMAL WINDBREAKER",
        price: 4499,
        tag: "SALE",
        images: [
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661294/windbreaker_wr4tgp.avif",
          "https://res.cloudinary.com/dqj2x8qjx/image/upload/q_auto/f_auto/v1777661391/windbreaker2_meihsp.webp",
        ],
      },
    ],
  },
};

export default products;
